//#region package/multicol/provides.ts
var macros = { columnbreak: { renderInfo: { breakAround: true } } };
var environments = {
	multicols: { signature: "m o o" },
	"multicols*": { signature: "m o o" }
};
//#endregion
export { environments, macros };

//# sourceMappingURL=index.js.map